import EditLinkModal from './EditLinkModal';
import LinksPage from './LinksPage';

export const components = {
  EditLinkModal,
  LinksPage,
};
